import React, { useCallback, useEffect, useState, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
const BUYERS = [{
  name: 'Sarah K.',
  location: 'California',
  time: '12 min ago'
}, {
  name: 'Emily W.',
  location: 'Ontario',
  time: '34 min ago'
}, {
  name: 'Jessica M.',
  location: 'Texas',
  time: '1 hour ago'
}, {
  name: 'Lauren T.',
  location: 'British Columbia',
  time: '2 hours ago'
}, {
  name: 'Rachel B.',
  location: 'New York',
  time: '3 hours ago'
}, {
  name: 'Megan H.',
  location: 'Alberta',
  time: '5 hours ago'
}];
export function SocialProofToast() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const showNext = useCallback(() => {
    setCurrentIndex(prev => (prev + 1) % BUYERS.length);
    setVisible(true);
    // Hide after 4 seconds
    setTimeout(() => {
      setVisible(false);
    }, 4000);
  }, []);
  useEffect(() => {
    // First appearance after 35 seconds
    const initialTimer = setTimeout(() => {
      showNext();
    }, 35000);
    return () => clearTimeout(initialTimer);
  }, [showNext]);
  useEffect(() => {
    if (!visible) {
      // Show next one 45-75 seconds after hiding
      const delay = 45000 + Math.random() * 30000;
      const timer = setTimeout(() => {
        showNext();
      }, delay);
      return () => clearTimeout(timer);
    }
  }, [visible, showNext]);
  const buyer = BUYERS[currentIndex];
  return <AnimatePresence data-id="element-722">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 10,
      scale: 0.95
    }} transition={{
      duration: 0.5,
      ease: [0.25, 0.1, 0.25, 1]
    }} className="fixed bottom-20 md:bottom-6 left-4 md:left-6 z-40 max-w-[280px]" data-id="element-723">
          <div className="flex items-center gap-3 pl-2 pr-4 py-2 rounded-2xl backdrop-blur-md" style={{
        background: 'rgba(250,247,242,0.95)',
        border: '1px solid rgba(61,50,41,0.08)',
        boxShadow: '0 8px 32px rgba(61,50,41,0.10), 0 2px 8px rgba(61,50,41,0.05), 0 0 0 1px rgba(250,247,242,0.5)'
      }} data-id="element-724">
            {/* Product mockup thumbnail */}
            <div className="w-11 h-11 rounded-xl overflow-hidden shrink-0" style={{
          boxShadow: '0 2px 8px rgba(196,133,106,0.15)',
          border: '1px solid rgba(196,133,106,0.12)'
        }} data-id="element-725">
              <img src="https://cdn.magicpatterns.com/uploads/cgH5PTGXcb6WQ2GR3YXGmG/mockup_thenap.png" alt="Soft Hold" loading="lazy" className="w-full h-full object-cover" data-id="element-726" />
            </div>
            <div className="min-w-0" data-id="element-727">
              <p className="text-brown text-[13px] font-medium leading-tight truncate" data-id="element-728">
                {buyer.name}{' '}
                <span className="text-brown/50 font-normal" data-id="element-729">
                  from {buyer.location}
                </span>
              </p>
              <p className="text-brown/40 text-[11px] mt-0.5" data-id="element-730">
                Just purchased · {buyer.time}
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}